export default () => {
  const init = () => {
    customElements.define("text-with-navigation", TextWithNavigation);
  };

  init();
};

class TextWithNavigation extends HTMLElement{
  constructor(){
    super()
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.loading = false;
    this.currentPage = 1;
    this.noMoreArticles = false;
    this.translations = window.SS.Strings.blog;
  }

  connectedCallback(){
    this.initializeElements();
    this.setEventListeners();
  }

  disconnectedCallback() {
    this.articleLinks.forEach((link) =>{
      link.removeEventListener('click', () => this.openPopUp)
    });
    this.closeBtns.forEach(btn => {
      btn.removeEventListener('click', () => this.closePopUp);
    });
  }

  initializeElements(){
    this.articleLinks = this.querySelectorAll('.article-link') || null;
    this.closeBtns = this.querySelectorAll('.close-btn') || null;
    this.blogWrapper = this.querySelector('#articles-container') || null;
    this.blogHandle = this.blogWrapper.dataset.blogHandle;
    this.articleWrapper = this.querySelectorAll('.article-wrapper.hidden');
    this.loadLimit = parseInt(this.blogWrapper.dataset.limitToShow, 10);
    this.currentlyShown = this.loadLimit;
    this.loader = this.querySelector('#loader');
  }

  setEventListeners(){
    this.blogWrapper.addEventListener('click', (event) => {
      const articleLink = event.target.closest('.article-link');
      if (articleLink) {
        this.openPopUp(articleLink);
      }
      const closeBtn = event.target.closest('.close-btn');
      if (closeBtn) {
        this.closePopUp(closeBtn);
      }
    });
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 300) {
      this.loadMoreArticles();
    }
  }

  async loadMoreArticles() {
    if (this.loading || this.noMoreArticles) return;

    this.loading = true;
    this.showLoader();

    try {
      const url = `/blogs/${this.blogHandle}?page=${this.currentPage}`;

      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      let newArticles = Array.from(doc.querySelectorAll('article.relative.card__article'));

      if (this.currentPage === 1) {
        newArticles = newArticles.slice(6);
      }

      newArticles = newArticles.slice(0, this.loadLimit);

      if (newArticles.length > 0) {
        this.renderArticles(newArticles);
        this.currentPage += 1;
      } else {
        this.noMoreArticles = true;
        window.removeEventListener('scroll', this.handleScroll.bind(this));
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error fetching articles:', error);
    } finally {
      this.loading = false;
      this.hideLoader();
    }
  }

  renderArticles(articles) {
    const container = this.querySelector('#articles-container');
    articles.forEach(article => {
      const articleWrapper = document.createElement('div');
      articleWrapper.className = 'article-wrapper';
      const articleLink = article.querySelector('a').getAttribute('href');
      const articleId = article.getAttribute('aria-labelledby');
      const articleImage = article.querySelector('img').getAttribute('src');
      const articleTitle = article.querySelector('h3').textContent;
      const articleDate = article.querySelector('time').textContent;
      const articleContent = `
      <div class="article-link cursor-pointer" data-article-id="${articleId}">
        <div class="mb-5">
          <img src="${articleImage}" loading='lazy' class="w-full">
        </div>
        <h4>${articleTitle}</h4>
        <span class="body-4 uppercase text-text_gray">
          ${articleDate}
        </span>
      </div>

      <div class="preview hidden fixed top-0 left-0 right-0 bottom-0 overflow-y-auto bg-main_bg z-50" id="${articleId}">
        <button class="close-btn absolute top-11 right-11 cursor-pointer">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke-width="1.5" 
            stroke="currentColor" 
            aria-label="Plus" 
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <div>
          <div class="preview-header text-center lg:pt-16 lg:pb-11 pt-8 pb-7 px-6 ">
            <h5 class="mb-2 !text-26">${articleTitle}</h5>
            <span class="body-4 uppercase text-text_gray">
              ${articleDate}
            </span>
          </div>
          <div class="preview-body flex">
            <img src="${articleImage}" class="block mx-auto h-full max-w-3xl">
          </div>
          <div class="preview-open-button text-center py-14">
            <a href="${articleLink}" class="body-4 uppercase relative hover:no-underline">
              ${this.translations.viewAllArticle}
              <span class="absolute left-0 w-full h-px bg-current -bottom-0.5 opacity-1"></span>
            </a>
          </div>
        </div>
      </div>
    `;

      articleWrapper.innerHTML = articleContent;
      container.appendChild(articleWrapper);
    });
  }

  showLoader() {
    this.loader.classList.remove('hidden');
  }

  hideLoader() {
    this.loader.classList.add('hidden');
  }

  openPopUp(articleLink) {
    const articleWrapper = articleLink.closest('.article-wrapper');
    const previewElement = articleWrapper ? articleWrapper.querySelector('.preview') : null;

    if (previewElement) {
      previewElement.classList.remove('hidden');
    }
  }

  closePopUp(currentTarget) {
    const { closestPreview } = { closestPreview: currentTarget.closest('.preview') };
    if (closestPreview) {
      closestPreview.classList.add('hidden');
    }
  }
}
